import { client } from '../client';
import { IGMConversation } from './types/IGMConversation';
import { getStaffScopedApiPrefix } from '@brands/Utils/staffScopedApiPrefix';

export const leaveConversation = async (
  conversation_sid: string | undefined,
  userRole?: string,
): Promise<IGMConversation> => {
  const prefix = getStaffScopedApiPrefix(userRole);
  const { data } = await client.patch(`${prefix}/conversations/${conversation_sid}/leave`, {});

  return data;
};
